export default "__VITE_ASSET__f74c6d09__"